/**
 * Maps a backend error_code to a frontend i18n key under the dataUpload
 * namespace's `backendErrors.*` subtree. Returns null when the code is
 * unknown so the caller can fall back to the raw BE message.
 */

export const KNOWN_BACKEND_ERROR_CODES = [
  'VALIDATION_ERROR',
  'MISSING_PARAMETER',
  'INVALID_PARAMETER',
  'DELIMITER_MISMATCH',
  'INVALID_COLUMN_INDEX',
  'PARSING_ERROR',
  'CSV_PARSING_ERROR',
  'DATETIME_PARSING_ERROR',
  'ENCODING_ERROR',
  'UPLOAD_ERROR',
  'CHUNK_UPLOAD_ERROR',
  'UPLOAD_NOT_FOUND',
  'INCOMPLETE_UPLOAD',
  'TIMEZONE_ERROR',
  'UNSUPPORTED_TIMEZONE',
  'TIMEZONE_CONVERSION_ERROR',
  'LOAD_DATA_ERROR',
] as const;

export type BackendErrorCode = (typeof KNOWN_BACKEND_ERROR_CODES)[number];

export interface BackendErrorInput {
  code: string | undefined;
  message: string | undefined;
}

export interface BackendErrorMapping {
  translationKey: string | null;
  fallbackMessage: string;
}

const KNOWN_SET = new Set<string>(KNOWN_BACKEND_ERROR_CODES);

export function mapBackendError(input: BackendErrorInput): BackendErrorMapping {
  const message = input.message ?? '';
  if (input.code && KNOWN_SET.has(input.code)) {
    return { translationKey: `backendErrors.${input.code}`, fallbackMessage: message };
  }
  return { translationKey: null, fallbackMessage: message };
}
